import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IStockCountInfo_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockCountInfo_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  HS_StockGetInfoByCountNo: any[];
  HS_StockGetInfoByCountNo_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  isComp869753Visible: "visible" | "hidden";
  isComp826294Visible: "visible" | "hidden";
  isComp803531Visible: "visible" | "hidden";
  isComp526196Visible: "visible" | "hidden";
  isComp119724Visible: "visible" | "hidden";
  isComp210416Visible: "visible" | "hidden";
  isComp734830Visible: "visible" | "hidden";
  isComp225201Visible: "visible" | "hidden";
}

export class StockCountInfo_ScreenBase extends React.PureComponent<
  IStockCountInfo_ScreenProps,
  any
> {
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "98036e8b-9d68-443d-b89e-27b953d58943",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 869753, PropertyName: "value", Value: "ERP Sayım Kodu" },
        { Id: 826294, PropertyName: "value", Value: "Geçici Sayım Kodu" },
        { Id: 337787, PropertyName: "value", Value: "Sayılan Ürün Sayısı" },
        { Id: 538236, PropertyName: "value", Value: "Durum" },
        { Id: 483549, PropertyName: "value", Value: "Başlangıç Tarihi" },
        { Id: 988721, PropertyName: "value", Value: "Bitiş Tarihi" },
        { Id: 210416, PropertyName: "value", Value: "Devam Eden Sayım" },
        { Id: 985769, PropertyName: "value", Value: "Ofis Kodu" },
        { Id: 990263, PropertyName: "value", Value: "Mağaza Kodu" },
        { Id: 460052, PropertyName: "value", Value: "Depo Kodu" },
        { Id: 132234, PropertyName: "value", Value: "ERP TRANSFER" },
        { Id: 734830, PropertyName: "value", Value: "EVET" },
        { Id: 225201, PropertyName: "value", Value: "HAYIR" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromLocalStorage: "",
      HS_StockGetInfoByCountNo: [],
      GoBack: "",
      isComp869753Visible: "hidden",
      isComp826294Visible: "hidden",
      isComp803531Visible: "hidden",
      isComp526196Visible: "hidden",
      isComp119724Visible: "hidden",
      isComp210416Visible: "hidden",
      isComp734830Visible: "hidden",
      isComp225201Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stockcountinfo", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.StockCountInfoPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stockcountinfo", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stockcountinfo", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockCountInfoPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  StockCountInfoPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CountHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountInfoPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  StockCountInfoPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountInfo/StockCountInfoPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.HS_StockGetInfoByCountNo = result?.data.hS_StockGetInfoByCountNo;
    formVars.stockcountinfo_803531_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countNo
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countNo
        : null
    );
    formVars.stockcountinfo_526196_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
        : null
    );
    formVars.stockcountinfo_383066_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].totalCountQty
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].totalCountQty
        : null
    );
    formVars.stockcountinfo_332318_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].statuName
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].statuName
        : null
    );
    formVars.stockcountinfo_531119_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countStartDate
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countStartDate
        : null
    );
    formVars.stockcountinfo_119724_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
        : null
    );
    formVars.stockcountinfo_350135_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].officeCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].officeCode
        : null
    );
    formVars.stockcountinfo_416701_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].officeCodeDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].officeCodeDescription
        : null
    );
    formVars.stockcountinfo_982853_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].storeCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].storeCode
        : null
    );
    formVars.stockcountinfo_375669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].storeCodeDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].storeCodeDescription
        : null
    );
    formVars.stockcountinfo_628028_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].warehouseCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].warehouseCode
        : null
    );
    formVars.stockcountinfo_181535_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].warehouseDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].warehouseDescription
        : null
    );
    stateVars.isComp869753Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp826294Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp803531Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp526196Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp119724Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp210416Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp734830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp225201Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountInfoPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountInfoPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp869753Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp826294Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stockcountinfo_803531_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countNo
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countNo
        : null
    );

    stateVars.isComp803531Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stockcountinfo_526196_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
        : null
    );

    stateVars.isComp526196Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stockcountinfo_383066_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].totalCountQty
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].totalCountQty
        : null
    );

    formVars.stockcountinfo_332318_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].statuName
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].statuName
        : null
    );

    formVars.stockcountinfo_531119_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countStartDate
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countStartDate
        : null
    );

    formVars.stockcountinfo_119724_value = ReactSystemFunctions.value(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
        : null
    );

    stateVars.isComp119724Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp210416Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].countEndDate
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].countEndDate
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stockcountinfo_350135_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].officeCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].officeCode
        : null
    );

    formVars.stockcountinfo_416701_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].officeCodeDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].officeCodeDescription
        : null
    );

    formVars.stockcountinfo_982853_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].storeCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].storeCode
        : null
    );

    formVars.stockcountinfo_375669_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].storeCodeDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].storeCodeDescription
        : null
    );

    formVars.stockcountinfo_628028_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].warehouseCode
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].warehouseCode
        : null
    );

    formVars.stockcountinfo_181535_value = ReactSystemFunctions.toString(
      this,
      stateVars.HS_StockGetInfoByCountNo !== undefined
        ? stateVars.HS_StockGetInfoByCountNo?.length > 0
          ? stateVars.HS_StockGetInfoByCountNo[0].warehouseDescription
          : null
        : this.state.HS_StockGetInfoByCountNo?.length > 0
        ? this.state.HS_StockGetInfoByCountNo[0].warehouseDescription
        : null
    );

    stateVars.isComp734830Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp225201Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.HS_StockGetInfoByCountNo !== undefined
            ? stateVars.HS_StockGetInfoByCountNo?.length > 0
              ? stateVars.HS_StockGetInfoByCountNo[0].erpDocumentNo
              : null
            : this.state.HS_StockGetInfoByCountNo?.length > 0
            ? this.state.HS_StockGetInfoByCountNo[0].erpDocumentNo
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockCountInfoComponent_60408_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockCountInfoPageInit();
    }
  }
}
